import Icon, { COLORS, ICONS } from "../../../../general-ui/icon";
import classNames from 'classnames';
import { SurveyType } from "../../../../../types/working-model";
import { useTranslate } from "../../../../../i18n/useTranslationModules";

interface ISurveyOptionProps {
	selected: boolean;
	percentage: number | null;
	value: string | number;
	onClick: (value: string | number) => void;
	title: string;
	disabled?: boolean;
	surveyType?: SurveyType;
	isCorrect?: boolean;
}

const SurveyOption: React.FC<ISurveyOptionProps> = ({ title, selected, value, percentage, onClick, disabled, surveyType, isCorrect }) => {
	const { t } = useTranslate("session");

	const handleClick = () => {
		if (!disabled)
			onClick(value);
	};

	return (
		<div className={classNames('survey-option-container')}>
			<button
				className="no-style clear survey-option focus-visible"
				onClick={handleClick}
			>
				{surveyType !== SurveyType.quiz &&
					<div className="survey-option-progress-bar-container">
						<div className="survey-option-progress-bar" style={percentage ? { width: `${percentage}%` } : { width: 0 }} />
					</div>
				}

				<div className="survey-option-content">
					<div className="survey-option-title">{title}</div>
					{surveyType !== SurveyType.quiz ? (
						<div className={selected ? 'survey-option-selected-answer-container' : ''}>
							<div className={classNames("survey-option-check", { disabled })}>
								<div style={{ visibility: selected ? 'visible' : 'hidden' }}>
									<Icon name={ICONS.CHECK_CIRCLE_FILLED} color={COLORS.WHITE} size={16} />
								</div>
								<div className="survey-option-percentage-text">{percentage ? `${percentage}%` : ''}</div>
							</div>
						</div>
					) : (
						<div className={selected ? 'survey-option-selected-answer-container' : ''}>
							{disabled &&
								<div className="survey-option-check-quiz">
									{selected &&
										<div className="survey-option-pill">
											{t('session:userSurvey.yourAnswer')}
										</div>
									}
									{isCorrect ?
										<Icon name={ICONS.CHECK_CIRCLE_FILLED} color={COLORS.GREEN} size={16} />
										: <Icon name={ICONS.ADD_CLOSE_CIRCLE} color={COLORS.RED} size={16} />
									}
								</div>
							}
						</div>
					)}
				</div>
			</button>
		</div>
	);
};

export default SurveyOption;
